import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PostRequestCached } from "../generics/helper";

const BrandAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], editMode = false, disabled = false, extraParam, isFormikFormField = false, brandsFor, showFormError = false, ...rest } = props;
    let brandOptions = [];
    if (allOption) {
        brandOptions.push({ brandName: 'All Brands', brandId: '' });
    }
    let initialProps = {
        ...rest,
        labelKey: 'brandName',
        primaryKey: 'brandId',
        options: brandOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        editMode,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getBrandOptions = async () => {
            let getBrandParams = {};
            if (brandsFor && brandsFor !== '') {
                getBrandParams = { ...getBrandParams, getFullDetails: 'Y', searchSuperCategories: brandsFor }
            }
            const response = await PostRequestCached(`masters/getBrands?${extraParam}`, getBrandParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption) {
                    newOptions.push({ brandName: 'All Brands', brandId: '' });
                }
                if (response.data.brands.length > 0) {
                    newOptions = newOptions.concat(response.data.brands);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((b) => selectedValues.indexOf(b.brandId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getBrandOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandsFor]);
    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((b) => selectedValues.indexOf(b.brandId) >= 0);
        }
        setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode, selectedValues]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default BrandAutocomplete;